import { render, staticRenderFns } from "./ListagemCategorias.vue?vue&type=template&id=13f40eea"
import script from "./ListagemCategorias.vue?vue&type=script&lang=js"
export * from "./ListagemCategorias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports